module.exports = __webpack_public_path__ + "static/media/wheels.2adda986.mp3";